let isRefreshing = false
let subscribers = []

function subscribeTokenRefresh(cb) {
  subscribers.push(cb)
}

function onRefreshed() {
  subscribers.map((cb) => cb())
}

export function setupAxiosInterceptors(axios, store) {
  /**
   * Axios request interceptor
   */
  axios.interceptors.request.use(async (config) => {
    const jwtToken = await store.getters['staff/getAccessToken']
    if (jwtToken) {
      config.headers.Authorization = 'Bearer ' + jwtToken
    }

    return config
  })

  /**
   * Axios response interceptors
   */
  axios.interceptors.response.use(
    (response) => {
      return response
    },
    async (err) => {
      if (!err.response) {
        return Promise.reject(err)
      }

      const { config, response } = err
      const { status } = response
      let { data } = response

      const originalRequest = config

      // Binary responses (arraybuffer/blob) carry the error body as raw bytes —
      // decode it so the 1401 expired-token check works for those requests too.
      if (data instanceof ArrayBuffer) {
        try {
          data = JSON.parse(new TextDecoder().decode(new Uint8Array(data)))
        } catch (e) {
          data = {}
        }
      } else if (data instanceof Blob) {
        try {
          data = JSON.parse(await data.text())
        } catch (e) {
          data = {}
        }
      }

      if (status === 401 && data.code == 1401) {
        console.log(data)

        if (isRefreshing) {
          // A refresh is already in flight — queue this request and replay it
          // only after onRefreshed() fires with the new token in place.
          return new Promise((resolve) => {
            subscribeTokenRefresh(() => {
              resolve(axios(originalRequest))
            })
          })
        }

        isRefreshing = true
        try {
          await store.dispatch('staff/refreshToken')
          // Token refreshed — replay queued requests, then this one.
          onRefreshed()
        } catch (refreshError) {
          console.error('Refresh Token Expired')
          store.dispatch('staff/destroyAuth')
          return Promise.reject(refreshError)
        } finally {
          isRefreshing = false
          subscribers = []
        }

        return axios(originalRequest)
      }
      return Promise.reject(err)
    }
  )

  subscribers = []
}
